export default class Routes {
    static home = 'home';
    static give = 'give';
    static videos = 'videos';
    static about = 'about';
    static jerry = 'jerry';
    static contact = 'contact';
}